import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "display-1" }, [
        _vm._v(_vm._s(_vm.$t("requests.requests_title")) + " de tablas"),
      ]),
      _c(
        "actions-component",
        { attrs: { class_table: _vm.getClassTable } },
        [
          _c(
            "template",
            { slot: "description" },
            [
              _c(VBreadcrumbs, {
                staticClass: "pa-0",
                attrs: { items: _vm.getBreadcrumbs },
              }),
            ],
            1
          ),
          _c(
            "template",
            { slot: "actions" },
            [
              _c(
                VBtn,
                {
                  staticClass: "ml-1 btn-inca-secondary",
                  attrs: { outlined: "", dense: "" },
                  on: { click: _vm.onDownload },
                },
                [
                  _c(VIcon, { attrs: { small: "" } }, [
                    _vm._v("icon-download"),
                  ]),
                  _vm._v(_vm._s(_vm.$t("btns.download"))),
                ],
                1
              ),
              _c(
                VBtn,
                {
                  staticClass: "ml-1 btn-inca-secondary",
                  attrs: { dense: "", outlined: "" },
                  on: { click: _vm.onEnableFilter },
                },
                [
                  _vm.filter_enabled
                    ? _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("mdi-filter-off-outline"),
                      ])
                    : _vm._e(),
                  !_vm.filter_enabled
                    ? _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("mdi-filter-outline"),
                      ])
                    : _vm._e(),
                  _vm._v(_vm._s(_vm.$t("btns.filter"))),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _vm.filter_enabled
        ? _c(
            VCard,
            { staticClass: "d-block d-md-none mb-2" },
            [
              _c(VCardTitle, { staticClass: "pointer" }, [
                _vm._v(_vm._s(_vm.$t("requests.search_filters"))),
              ]),
              _c(
                VCardText,
                { staticClass: "pa-2" },
                [
                  _c(VRow, { attrs: { dense: "" } }, [
                    _c(
                      "div",
                      { staticClass: "col-md-3" },
                      [
                        _c(
                          VMenu,
                          {
                            attrs: {
                              "close-on-content-click": false,
                              "nudge-right": 40,
                              transition: "scale-transition",
                              "offset-y": "",
                              "min-width": "290px",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function (ref) {
                                    var on = ref.on
                                    var attrs = ref.attrs
                                    return [
                                      _c(
                                        VTextField,
                                        _vm._g(
                                          _vm._b(
                                            {
                                              attrs: {
                                                label: _vm.$t(
                                                  "requests.search_from"
                                                ),
                                                "append-icon": "event",
                                                readonly: "",
                                                dense: "",
                                                outlined: "",
                                                placeholder: _vm.$t(
                                                  "requests.search_from"
                                                ),
                                                "hide-details": "auto",
                                              },
                                              on: { "click:append": on.click },
                                              model: {
                                                value: _vm.formattedStartDate,
                                                callback: function ($$v) {
                                                  _vm.formattedStartDate = $$v
                                                },
                                                expression:
                                                  "formattedStartDate",
                                              },
                                            },
                                            "v-text-field",
                                            attrs,
                                            false
                                          ),
                                          on
                                        )
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1181553663
                            ),
                            model: {
                              value: _vm.menu3,
                              callback: function ($$v) {
                                _vm.menu3 = $$v
                              },
                              expression: "menu3",
                            },
                          },
                          [
                            _c(VDatePicker, {
                              on: { input: _vm.onStartDateChange },
                              model: {
                                value: _vm.toFilter.startDate,
                                callback: function ($$v) {
                                  _vm.$set(_vm.toFilter, "startDate", $$v)
                                },
                                expression: "toFilter.startDate",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-md-3" },
                      [
                        _c(
                          VMenu,
                          {
                            attrs: {
                              "close-on-content-click": false,
                              "nudge-right": 40,
                              transition: "scale-transition",
                              "offset-y": "",
                              "min-width": "290px",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function (ref) {
                                    var on = ref.on
                                    var attrs = ref.attrs
                                    return [
                                      _c(
                                        VTextField,
                                        _vm._g(
                                          _vm._b(
                                            {
                                              attrs: {
                                                label:
                                                  _vm.$t("requests.search_to"),
                                                "append-icon": "event",
                                                readonly: "",
                                                dense: "",
                                                outlined: "",
                                                placeholder:
                                                  _vm.$t("requests.search_to"),
                                                "hide-details": "auto",
                                              },
                                              on: { "click:append": on.click },
                                              model: {
                                                value: _vm.formattedEndDate,
                                                callback: function ($$v) {
                                                  _vm.formattedEndDate = $$v
                                                },
                                                expression: "formattedEndDate",
                                              },
                                            },
                                            "v-text-field",
                                            attrs,
                                            false
                                          ),
                                          on
                                        )
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3145478512
                            ),
                            model: {
                              value: _vm.menu4,
                              callback: function ($$v) {
                                _vm.menu4 = $$v
                              },
                              expression: "menu4",
                            },
                          },
                          [
                            _c(VDatePicker, {
                              on: { input: _vm.onEndDateChange },
                              model: {
                                value: _vm.toFilter.endDate,
                                callback: function ($$v) {
                                  _vm.$set(_vm.toFilter, "endDate", $$v)
                                },
                                expression: "toFilter.endDate",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-md-3" },
                      [
                        _c(VSelect, {
                          attrs: {
                            label: _vm.$t("requests.type"),
                            placeholder: _vm.$t("requests.type"),
                            outlined: "",
                            dense: "",
                            type: "text",
                            items: _vm.types,
                            clearable: "",
                          },
                          model: {
                            value: _vm.toFilter.type,
                            callback: function ($$v) {
                              _vm.$set(_vm.toFilter, "type", $$v)
                            },
                            expression: "toFilter.type",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-md-3" },
                      [
                        _c(VSelect, {
                          attrs: {
                            label: _vm.$t("requests.status"),
                            placeholder: _vm.$t("requests.status"),
                            type: "text",
                            outlined: "",
                            dense: "",
                            items: _vm.statuses,
                            clearable: "",
                          },
                          model: {
                            value: _vm.toFilter.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.toFilter, "status", $$v)
                            },
                            expression: "toFilter.status",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-md-3" },
                      [
                        _vm.isAdmin
                          ? _c("OrganizacionComponent", {
                              attrs: {
                                value: {
                                  text: "Default Organization",
                                  value: "default_value",
                                },
                                show_all: true,
                                disabled: _vm.domain !== "intercorp.com.pe",
                              },
                              model: {
                                value: _vm.toFilter.organization,
                                callback: function ($$v) {
                                  _vm.$set(_vm.toFilter, "organization", $$v)
                                },
                                expression: "toFilter.organization",
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-md-3" },
                      [
                        _vm.isAdmin
                          ? _c(VTextField, {
                              attrs: {
                                label: _vm.$t("requests.applicant"),
                                placeholder: _vm.$t("requests.applicant"),
                                type: "text",
                                outlined: "",
                                dense: "",
                                clearable: "",
                              },
                              model: {
                                value: _vm.toFilter.applicant,
                                callback: function ($$v) {
                                  _vm.$set(_vm.toFilter, "applicant", $$v)
                                },
                                expression: "toFilter.applicant",
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-md-3 text-right" },
                      [
                        _c(
                          VBtn,
                          {
                            staticClass: "default mr-1",
                            attrs: { outlined: "" },
                            on: { click: _vm.onLimpiar },
                          },
                          [_vm._v(_vm._s(_vm.$t("btns.clean")))]
                        ),
                        _c(
                          VBtn,
                          {
                            staticClass: "primary ",
                            on: { click: _vm.getActivitiesFront },
                          },
                          [_vm._v(_vm._s(_vm.$t("btns.search")))]
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(VRow, [
        _c(
          "div",
          { class: _vm.getClassTable },
          [
            _c(
              VCard,
              [
                _c(VDataTable, {
                  staticClass: "table-inca",
                  attrs: {
                    items: _vm.serverItems,
                    headers: _vm.tableFields,
                    loading: _vm.loadingPage,
                    "item-key": "__rowKey",
                    "hide-default-footer": "",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "item.table_id",
                      fn: function (row) {
                        return [
                          row.item.tableReference
                            ? _c("div", { staticClass: "text-left" }, [
                                _c("b", { staticClass: "table-name" }, [
                                  _vm._v(
                                    _vm._s(row.item.tableReference.tableId)
                                  ),
                                ]),
                                _c(
                                  "a",
                                  {
                                    staticClass: "compose-name",
                                    attrs: { title: row.item.id },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("joinTableReference")(
                                          row.item.tableReference
                                        )
                                      )
                                    ),
                                  ]
                                ),
                              ])
                            : row.item.objectReference
                            ? _c("div", { staticClass: "text-left" }, [
                                _c("b", { staticClass: "table-name" }, [
                                  _vm._v(
                                    _vm._s(row.item.objectReference.object_name)
                                  ),
                                ]),
                                _c(
                                  "a",
                                  {
                                    staticClass: "compose-name",
                                    attrs: { title: row.item.id },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(row.item.objectReference.path_name)
                                    ),
                                  ]
                                ),
                              ])
                            : row.item.resource_name
                            ? _c("div", { staticClass: "text-left" }, [
                                _c("b", [
                                  _vm._v(_vm._s(row.item.resource_name)),
                                ]),
                              ])
                            : _c("div", { staticClass: "text-left" }, [
                                _c("b", [
                                  _vm._v(_vm._s(row.item.business_term)),
                                ]),
                              ]),
                        ]
                      },
                    },
                    {
                      key: "item.actions",
                      fn: function (row) {
                        return [
                          row.item.tableReference &&
                          row.item.status &&
                          row.item.relativeResourceName
                            ? _c(
                                VBtn,
                                {
                                  attrs: {
                                    outlined: "",
                                    small: "",
                                    color: "secondary",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.showItemDetails(row.item)
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("requests.details")))]
                              )
                            : row.item.objectReference && row.item.status
                            ? _c(
                                VBtn,
                                {
                                  attrs: {
                                    outlined: "",
                                    small: "",
                                    color: "secondary",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onTableauOwnerDs(row.item)
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("requests.details")))]
                              )
                            : row.item.type === "TEMPORAL_OPERATOR"
                            ? _c(
                                VBtn,
                                {
                                  attrs: {
                                    outlined: "",
                                    small: "",
                                    color: "secondary",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onClickTemporalDataOperator(
                                        row.item
                                      )
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("requests.details")))]
                              )
                            : row.item.business_term
                            ? _c(
                                VBtn,
                                {
                                  attrs: {
                                    outlined: "",
                                    small: "",
                                    disabled: "",
                                  },
                                },
                                [_vm._v(_vm._s(row.item.log_type))]
                              )
                            : _vm._e(),
                          row.item.applicant === _vm.toFilter.email &&
                          row.item.status === "REVISION"
                            ? _c(
                                VBtn,
                                {
                                  attrs: {
                                    outlined: "",
                                    small: "",
                                    color: "secondary",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.cancelRequest(row.item)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("requests.cancel_request"))
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
                _c("pagination-firestore", {
                  key: _vm.key_pagination,
                  attrs: { pagination: _vm.pagination, pageType: "2" },
                  on: { changePagina: _vm.changePage },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _vm.filter_enabled
          ? _c(
              "div",
              { staticClass: "col-md-3 d-none d-md-block pl-0" },
              [
                _c(
                  VCard,
                  [
                    _c(VCardTitle, { staticClass: "pointer" }, [
                      _vm._v(_vm._s(_vm.$t("titles.search_filters"))),
                    ]),
                    _c(
                      VCardText,
                      { staticClass: "pa-2 pt-0" },
                      [
                        _c(
                          VRow,
                          { attrs: { dense: "" } },
                          [
                            _c(VCol, { attrs: { cols: "12" } }, [
                              _c(
                                "div",
                                { staticClass: "mb-3" },
                                [
                                  _c(
                                    VMenu,
                                    {
                                      attrs: {
                                        "close-on-content-click": false,
                                        "nudge-right": 40,
                                        transition: "scale-transition",
                                        "offset-y": "",
                                        "min-width": "290px",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function (ref) {
                                              var on = ref.on
                                              var attrs = ref.attrs
                                              return [
                                                _c(
                                                  VTextField,
                                                  _vm._g(
                                                    _vm._b(
                                                      {
                                                        attrs: {
                                                          label: _vm.$t(
                                                            "requests.search_from"
                                                          ),
                                                          "append-icon":
                                                            "event",
                                                          readonly: "",
                                                          dense: "",
                                                          outlined: "",
                                                          placeholder: _vm.$t(
                                                            "requests.search_from"
                                                          ),
                                                          "hide-details":
                                                            "auto",
                                                        },
                                                        on: {
                                                          "click:append":
                                                            on.click,
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.formattedStartDate,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.formattedStartDate =
                                                              $$v
                                                          },
                                                          expression:
                                                            "formattedStartDate",
                                                        },
                                                      },
                                                      "v-text-field",
                                                      attrs,
                                                      false
                                                    ),
                                                    on
                                                  )
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        1181553663
                                      ),
                                      model: {
                                        value: _vm.menu,
                                        callback: function ($$v) {
                                          _vm.menu = $$v
                                        },
                                        expression: "menu",
                                      },
                                    },
                                    [
                                      _c(VDatePicker, {
                                        on: { input: _vm.onStartDateChange },
                                        model: {
                                          value: _vm.toFilter.startDate,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.toFilter,
                                              "startDate",
                                              $$v
                                            )
                                          },
                                          expression: "toFilter.startDate",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]),
                            _c(VCol, { attrs: { cols: "12" } }, [
                              _c(
                                "div",
                                { staticClass: "mb-3" },
                                [
                                  _c(
                                    VMenu,
                                    {
                                      attrs: {
                                        "close-on-content-click": false,
                                        "nudge-right": 40,
                                        transition: "scale-transition",
                                        "offset-y": "",
                                        "min-width": "290px",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function (ref) {
                                              var on = ref.on
                                              var attrs = ref.attrs
                                              return [
                                                _c(
                                                  VTextField,
                                                  _vm._g(
                                                    _vm._b(
                                                      {
                                                        attrs: {
                                                          label:
                                                            _vm.$t(
                                                              "requests.search_to"
                                                            ),
                                                          "append-icon":
                                                            "event",
                                                          readonly: "",
                                                          dense: "",
                                                          outlined: "",
                                                          placeholder:
                                                            _vm.$t(
                                                              "requests.search_to"
                                                            ),
                                                          "hide-details":
                                                            "auto",
                                                        },
                                                        on: {
                                                          "click:append":
                                                            on.click,
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.formattedEndDate,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.formattedEndDate =
                                                              $$v
                                                          },
                                                          expression:
                                                            "formattedEndDate",
                                                        },
                                                      },
                                                      "v-text-field",
                                                      attrs,
                                                      false
                                                    ),
                                                    on
                                                  )
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        3145478512
                                      ),
                                      model: {
                                        value: _vm.menu2,
                                        callback: function ($$v) {
                                          _vm.menu2 = $$v
                                        },
                                        expression: "menu2",
                                      },
                                    },
                                    [
                                      _c(VDatePicker, {
                                        on: { input: _vm.onEndDateChange },
                                        model: {
                                          value: _vm.toFilter.endDate,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.toFilter,
                                              "endDate",
                                              $$v
                                            )
                                          },
                                          expression: "toFilter.endDate",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]),
                            _c(
                              VCol,
                              { attrs: { cols: "12" } },
                              [
                                _c(VSelect, {
                                  attrs: {
                                    label: _vm.$t("requests.type"),
                                    placeholder: _vm.$t("requests.type"),
                                    outlined: "",
                                    dense: "",
                                    type: "text",
                                    items: _vm.types,
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.toFilter.type,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.toFilter, "type", $$v)
                                    },
                                    expression: "toFilter.type",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              { attrs: { cols: "12" } },
                              [
                                _c(VSelect, {
                                  attrs: {
                                    label: _vm.$t("requests.status"),
                                    placeholder: _vm.$t("requests.status"),
                                    type: "text",
                                    outlined: "",
                                    dense: "",
                                    items: _vm.statuses,
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.toFilter.status,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.toFilter, "status", $$v)
                                    },
                                    expression: "toFilter.status",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              { attrs: { cols: "12" } },
                              [
                                _vm.isAdmin
                                  ? _c("OrganizacionComponent", {
                                      attrs: {
                                        value: {
                                          text: "Default Organization",
                                          value: "default_value",
                                        },
                                        show_all: true,
                                        disabled:
                                          _vm.domain !== "intercorp.com.pe",
                                      },
                                      model: {
                                        value: _vm.toFilter.organization,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.toFilter,
                                            "organization",
                                            $$v
                                          )
                                        },
                                        expression: "toFilter.organization",
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              { attrs: { cols: "12" } },
                              [
                                _vm.isAdmin
                                  ? _c(VTextField, {
                                      attrs: {
                                        label: _vm.$t("requests.applicant"),
                                        placeholder:
                                          _vm.$t("requests.applicant"),
                                        type: "text",
                                        outlined: "",
                                        dense: "",
                                        clearable: "",
                                      },
                                      model: {
                                        value: _vm.toFilter.applicant,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.toFilter,
                                            "applicant",
                                            $$v
                                          )
                                        },
                                        expression: "toFilter.applicant",
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              {
                                staticClass: "text-right",
                                attrs: { cols: "12" },
                              },
                              [
                                _c(
                                  VBtn,
                                  {
                                    staticClass: "default mr-1",
                                    attrs: { outlined: "" },
                                    on: { click: _vm.onLimpiar },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("btns.clean")))]
                                ),
                                _c(
                                  VBtn,
                                  {
                                    staticClass: "primary ",
                                    on: { click: _vm.getActivitiesFront },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("btns.search")))]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
      _c(
        "dialogs-component",
        {
          ref: _vm.MODAL_NAME_LOGS,
          attrs: {
            title: !_vm.itemDetail
              ? _vm.$t("requests.view_change_metadata")
              : _vm.$t("requests.view_request"),
            width: 1200,
          },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _vm.itemDetail != null && _vm.itemDetail.type == "CHANGE_METADATA"
                ? _c("form-metadata-change-response", {
                    attrs: {
                      userRequestMetadata: _vm.itemDetail,
                      serverActualMetadata: _vm.objToRequest,
                    },
                    on: {
                      submit: function ($event) {
                        return _vm.$refs[_vm.MODAL_NAME_LOGS].onClose()
                      },
                      cancel: function ($event) {
                        return _vm.$refs[_vm.MODAL_NAME_LOGS].onClose()
                      },
                    },
                  })
                : _vm.itemDetail != null && _vm.itemDetail.type == "ACCESS"
                ? _c("form-access-request-table-component", {
                    ref: "dialog",
                    attrs: { tplToWork: _vm.objToRequest },
                    on: {
                      submit: function ($event) {
                        return _vm.$refs[_vm.MODAL_NAME_LOGS].onClose()
                      },
                      cancel: function ($event) {
                        return _vm.$refs[_vm.MODAL_NAME_LOGS].onClose()
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm.objToRequest.tipo != "vista"
            ? _c(
                "template",
                { slot: "btnsRight" },
                [
                  _c(
                    VBtn,
                    {
                      attrs: { color: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.$refs["dialog"].onSubmit($event)
                        },
                      },
                    },
                    [
                      _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("icon-send"),
                      ]),
                      _vm._v(_vm._s(_vm.$t("btns.request"))),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        2
      ),
      _c(
        "b-modal",
        { attrs: { id: _vm.MODAL_NAME_LOGS, size: "xl", "hide-footer": "" } },
        [
          _vm.itemDetail != null && _vm.itemDetail.type == "CHANGE_METADATA"
            ? _c("template", { slot: "modal-title" }, [
                _c("span", [_vm._v("Change Metadata Request")]),
              ])
            : _vm._e(),
          _vm.itemDetail != null && _vm.itemDetail.type == "ACCESS"
            ? _c("template", { slot: "modal-title" }, [
                _c("span", [_vm._v("Access Request")]),
              ])
            : _vm._e(),
          _vm.itemDetail != null && _vm.itemDetail.type == "CHANGE_METADATA"
            ? _c(
                "div",
                { staticClass: "d-block" },
                [
                  _c("form-metadata-change-response", {
                    attrs: {
                      userRequestMetadata: _vm.itemDetail,
                      serverActualMetadata: _vm.objToRequest,
                    },
                    on: {
                      submit: function ($event) {
                        return _vm.$bvModal.hide(_vm.MODAL_NAME_LOGS)
                      },
                      cancel: function ($event) {
                        return _vm.$bvModal.hide(_vm.MODAL_NAME_LOGS)
                      },
                    },
                  }),
                ],
                1
              )
            : _vm.itemDetail != null && _vm.itemDetail.type == "ACCESS"
            ? _c(
                "div",
                { staticClass: "d-block" },
                [
                  _c("form-access-request", {
                    attrs: { tplToWork: _vm.objToRequest },
                    on: {
                      submit: function ($event) {
                        return _vm.$bvModal.hide(_vm.MODAL_NAME_LOGS)
                      },
                      cancel: function ($event) {
                        return _vm.$bvModal.hide(_vm.MODAL_NAME_LOGS)
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        2
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: _vm.MODAL_NAME_DATASOURCE,
            size: "xl",
            "hide-footer": "",
          },
          scopedSlots: _vm._u([
            {
              key: "modal-title",
              fn: function () {
                return [_c("span", [_vm._v(_vm._s(_vm.titleModal))])]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("form-change-meta-data-datasource", {
            attrs: { item: _vm.itemDetail, showFooter: false },
          }),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: { id: _vm.MODAL_NAME_WORKBOOK, size: "xl", "hide-footer": "" },
          scopedSlots: _vm._u([
            {
              key: "modal-title",
              fn: function () {
                return [_c("span", [_vm._v(_vm._s(_vm.titleModal))])]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("form-change-meta-data-workbook", {
            attrs: { item: _vm.itemDetail, showFooter: false },
          }),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: _vm.MODAL_NAME_TABLEAU_TEMPORAL_OPERATOR,
            size: "sm",
            "hide-footer": "",
          },
          scopedSlots: _vm._u([
            {
              key: "modal-title",
              fn: function () {
                return [_c("span", [_vm._v("Tableau Temporal Operator")])]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("form-temporal-assignment", {
            attrs: { record: _vm.temporalAssignmentRecord },
          }),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: _vm.MODAL_NAME_TABLE_TEMPORAL_OPERATOR,
            size: "sm",
            "hide-footer": "",
          },
          scopedSlots: _vm._u([
            {
              key: "modal-title",
              fn: function () {
                return [_c("span", [_vm._v("Table Temporal Operator")])]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("form-table-temporal-assignment", {
            attrs: { record: _vm.temporalAssignmentRecord },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }